$(document).ready(function(){
  $('.slider_section_main .slider_main').slick({
    dots: false,
    arrows: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1
        }
      }      
    ]
  });
    $(document).on("click", ".product_upseell .product_upsell_inner", function(){
    $(this).parents(".product_upseell").children(".product_upsell_inner").removeClass("active");
    $(this).addClass("active");
}) ; 
  $('#v2-hydro-spray-bottle .my_bundle').val('48865132609847'); //applicable on hydro-spray-bottle temperory fix
});



$(document).ready(function() {
  function addProductToCart(variantId, quantity) {
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        items: [
          {
            id: variantId,
            quantity: quantity
          }
        ]
      },
      dataType: 'json',
      success: function(response) {
        console.log('Product added to cart:', response);
      },
      error: function(xhr, status, error) {
        console.error('Error adding product to cart:', error);
      }
    });
  }
  function removeProductFromCart(variantId) {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: {
        id: variantId,
        quantity: 0
      },
      dataType: 'json',
      success: function(response) {
        console.log('Product removed from cart:', response);
      },
      error: function(xhr, status, error) {
        console.error('Error removing product from cart:', error);
      }
    });
  }

  function monitorCart() {
     $.getJSON('/cart.js', function(cart) {
     
      var targetProductId = '49517768180023'; // Replace with the variant ID of the product you want to monitor
      var autoAddProductId = '49514197418295'; // Replace with the variant ID of the product to be added automatically
      var TargetProductQuantity;
      var containsTargetProduct = cart.items.some(function(item) {
        return item.variant_id == targetProductId;
      });

      cart.items.some(function(item) {
        if(item.variant_id == targetProductId){
          TargetProductQuantity= item.quantity;
         }
      });
       
      $('#49514197418295\\:d3fd105a6c69da5a9eaff6f1c56cd718 .styles_QuantityField__SXbrJ .upcart-product-quantity-plus').hide();
      $('#49514197418295\\:d3fd105a6c69da5a9eaff6f1c56cd718 .styles_QuantityField__SXbrJ .upcart-product-quantity-minus').hide();
      $('#49514197418295\\:d3fd105a6c69da5a9eaff6f1c56cd718 .styles_QuantityField__SXbrJ .upcart-product-quantity-input').prop("readonly", true);

      $('#49839323382071\\:f497e227d9f6ab87208ab391c9dcece5 .styles_QuantityField__SXbrJ .upcart-product-quantity-plus').hide();
      $('#49839323382071\\:f497e227d9f6ab87208ab391c9dcece5 .styles_QuantityField__SXbrJ .upcart-product-quantity-minus').hide();
      $('#49839323382071\\:f497e227d9f6ab87208ab391c9dcece5 .styles_QuantityField__SXbrJ .upcart-product-quantity-input').prop("readonly", true);

      $('#49841672585527\\:5ee0c6364e93fb702867855d9d57ea46 .styles_QuantityField__SXbrJ .upcart-product-quantity-plus').hide();
      $('#49841672585527\\:5ee0c6364e93fb702867855d9d57ea46 .styles_QuantityField__SXbrJ .upcart-product-quantity-minus').hide();
      $('#49841672585527\\:5ee0c6364e93fb702867855d9d57ea46 .styles_QuantityField__SXbrJ .upcart-product-quantity-input').prop("readonly", true); 

      $('#49859236626743\\:553e2615f847b273f121519b161b3861 .styles_QuantityField__SXbrJ .upcart-product-quantity-plus').hide();
      $('#49859236626743\\:553e2615f847b273f121519b161b3861 .styles_QuantityField__SXbrJ .upcart-product-quantity-minus').hide();
      $('#49859236626743\\:553e2615f847b273f121519b161b3861 .styles_QuantityField__SXbrJ .upcart-product-quantity-input').prop("readonly", true); 

       
      
      var containsAutoAddProduct = cart.items.some(function(item) {
        return item.variant_id == autoAddProductId;
      });
       
   
       
      if (containsTargetProduct && !containsAutoAddProduct) {
            addProductToCart(autoAddProductId, TargetProductQuantity); 
       
      }

      if (!containsTargetProduct && containsAutoAddProduct) {
          removeProductFromCart(autoAddProductId); 
          $('#49514197418295\\:d3fd105a6c69da5a9eaff6f1c56cd718').remove();

         $('#49839323382071\\:f497e227d9f6ab87208ab391c9dcece5').remove();
         $('#49841672585527\\:5ee0c6364e93fb702867855d9d57ea46').remove();
        $('#49859236626743\\:553e2615f847b273f121519b161b3861').remove();
      }
    });   
  }
function enforceQuantityLimit() {
    $.getJSON('/cart.js', function(cart) {
      var bundleProductId = '49517768180023'; //replace with bundle product ID
      var targetVariantId = '49514197418295'; // Replace with your variant ID
      var targetQuantity = 1;
      var lineItem = cart.items.find(function(item) {
        return item.variant_id == targetVariantId;
      });

     cart.items.find(function(item) {
        if(item.variant_id == bundleProductId){
          targetQuantity = item.quantity;
        }       
      });
                    $.ajax({
                      type: 'POST',
                      url: '/cart/change.js',
                      data: {
                        id: lineItem.id,
                        quantity: targetQuantity
                      },
                      dataType: 'json',
                      success: function(response) {
                          console.log('Quantity adjusted:', response);
                          $('#49514197418295\\:d3fd105a6c69da5a9eaff6f1c56cd718 .styles_QuantityField__SXbrJ .upcart-product-quantity-input').val(targetQuantity);
                     },
                      error: function(xhr, status, error) {
                        console.error('Error adjusting quantity:', error);
                      }
                    });
          
    });
}  
      function enforceQuantityLimit1() {  
            $('#49514197418295\\:d3fd105a6c69da5a9eaff6f1c56cd718 .styles_QuantityField__SXbrJ .upcart-product-quantity-plus').hide();
            $('#49514197418295\\:d3fd105a6c69da5a9eaff6f1c56cd718 .styles_QuantityField__SXbrJ .upcart-product-quantity-minus').hide();
            $('#49514197418295\\:d3fd105a6c69da5a9eaff6f1c56cd718 .styles_QuantityField__SXbrJ .upcart-product-quantity-input').prop("readonly", true); 

        
      $('#49839323382071\\:f497e227d9f6ab87208ab391c9dcece5 .styles_QuantityField__SXbrJ .upcart-product-quantity-plus').hide();
      $('#49839323382071\\:f497e227d9f6ab87208ab391c9dcece5 .styles_QuantityField__SXbrJ .upcart-product-quantity-minus').hide();
      $('#49839323382071\\:f497e227d9f6ab87208ab391c9dcece5 .styles_QuantityField__SXbrJ .upcart-product-quantity-input').prop("readonly", true);
      
      $('#49841672585527\\:5ee0c6364e93fb702867855d9d57ea46 .styles_QuantityField__SXbrJ .upcart-product-quantity-plus').hide();
      $('#49841672585527\\:5ee0c6364e93fb702867855d9d57ea46 .styles_QuantityField__SXbrJ .upcart-product-quantity-minus').hide();
      $('#49841672585527\\:5ee0c6364e93fb702867855d9d57ea46 .styles_QuantityField__SXbrJ .upcart-product-quantity-input').prop("readonly", true); 

        $('#49859236626743\\:553e2615f847b273f121519b161b3861 .styles_QuantityField__SXbrJ .upcart-product-quantity-plus').hide();
      $('#49859236626743\\:553e2615f847b273f121519b161b3861 .styles_QuantityField__SXbrJ .upcart-product-quantity-minus').hide();
      $('#49859236626743\\:553e2615f847b273f121519b161b3861 .styles_QuantityField__SXbrJ .upcart-product-quantity-input').prop("readonly", true); 
      }

   
     function enforceQuantityLimit2() {  
            targetQuantity_cart =  $('.49517768180023_new').val();
            $('.49514197418295_new').val(targetQuantity_cart);
      } 
    function enforceQuantityLimit3() { 
           $.getJSON('/cart.js', function(cart) {
              var autoAddProductId = '49514197418295';
              var containsAutoAddProduct = cart.items.some(function(item) {
              return item.variant_id == autoAddProductId;
              });
              if(containsAutoAddProduct){
                    console.log('aasda');
                    $('form.upcart-discount-code-row').hide();
              }
              else
              {
                    $('form.upcart-discount-code-row').show();
              }
             });
      } 
      function handleButtonClick() {
          $('#UpcartPopup').addClass('add');   
          setTimeout(function() {
              runDelayedCode();
          }, 3000);
      }
        function runDelayedCode() {
              console.log('Running delayed code...');
              $('#UpcartPopup').removeClass('add');
        }
      function attachEventListenerToButton() {
        $('#UpcartPopup button.upcart-product-quantity-plus').on('click', handleButtonClick);
        $('#UpcartPopup button.upcart-product-quantity-minus').on('click', handleButtonClick);
      }

    setInterval(attachEventListenerToButton, 50);
setInterval(enforceQuantityLimit, 3000);
  setInterval(enforceQuantityLimit1, 50);
  setInterval(enforceQuantityLimit2, 50); 
    //setInterval(enforceQuantityLimit3, 100);
  setInterval(monitorCart, 4000);
});
